<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="orderCode" label="订单编号：">
        <el-input v-model="dataForm.orderCode" size="mini" clearable type="text"
                  placeholder="采购批次"></el-input>
      </el-form-item>
      <el-form-item prop="batchCode" label="批次号：">
        <el-input v-model="dataForm.batchCode" size="mini" clearable type="text"
                  placeholder="加工批次"></el-input>
      </el-form-item>
      <el-form-item prop="receiverName" label="收货方："  v-if="optType===10">
        <el-input v-model="dataForm.receiverName" size="mini" clearable type="text"
                  placeholder="收货方"></el-input>
      </el-form-item>
      <el-form-item prop="productCode" label="品番号：" v-if="optType===20">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品番号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：" v-if="optType===20">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="nameZh" label="中文品名：" v-if="optType===20">
        <el-input
            v-model="dataForm.nameZh"
            size="mini"
            clearable
            type="text"
            placeholder="中文品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" :label="`${showName}名称：`" >
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            :placeholder="`${showName}名称`"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：" >
        <el-input
            v-model="dataForm.materialColor"
            size="mini"
            clearable
            type="text"
            placeholder="物料颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：" >
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="物料规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽："  v-if="optType===10">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="物料规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：" v-if="optType===10">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="物料规格"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="justify-content: left;margin-bottom: 0px;">
      <div class="bar-item">
        <el-button type="primary" @click="doSend(optType)" size="mini" v-if="$hasPermission('erp:receive:send')">去发货
        </el-button>
        <el-button type="warning"@click="doSend(30)" size="mini" v-if="optType===20&&$hasPermission('erp:receive:send')">箱单发货
        </el-button>

      </div>
    </div>
    <SweetTable ref="table" :selection="true" :url="queryUrl" :query-form="dataForm">
      <el-table-column
          prop="orderCode"
          label="订单编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="batchCode"
          label="批次号"
          header-align="center"
          align="center"
          min-width="90"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="storageName"
          label="收货方"
          header-align="center"
          align="center"
          min-width="90"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          v-if="optType===20"
          prop="product.code"
          label="品番号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===20"
          prop="product.skuCode"
          label="SKU"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===20"
          prop="product.nameZh"
          label="中文品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===20"
          prop="product.skuCode"
          label="SKU"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===10"
          prop="product.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===10"
          prop="product.attr2"
          label="克重"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="amount" label="单价" width="100" header-align="center" align="center">
      </el-table-column>
      <el-table-column
          prop="count"
          label="数量"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="已发货"
          header-align="center"
          align="center"
          prop="sendCount"
          width="100"
      >
      </el-table-column>
      <el-table-column
          prop="receivedCount"
          label="已收货"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="realPriceShow"
          label="退货"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>

      <el-table-column
          label="交期"
          header-align="center"
          align="center"
          prop="deadline"
          width="100"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="下单人"
          header-align="center"
          align="center"
          prop="creatorName"
          width="120"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="下单时间"
          header-align="center"
          align="center"
          prop="createDate"
          width="160"
      >
      </el-table-column>
    </SweetTable>
    <SendDialog ref="SendDialog" :opt-type="sendOptType" @change="()=>{this.getDataList();this.$refs.table.clearSelection();}"></SendDialog>
  </div>
</template>

<script>
import SendDialog from './send-dialog.vue'
import SweetTable from '@/mixins/SweetTable'

export default {
  mixins: [SweetTable],
  components: { SendDialog },
  props:{
    optType:{//操作类型,10物料发货,20成品发货,30箱单发货
      type:Number,
      default:null
    },
    queryUrl:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      dateArr: [],
      currentId: '',
      sendOptType:0,//操作类型,10物料发货,20成品发货,30箱单发货
      dataForm: {
        orderCode: '',
        batchCode: '',
        productCode: '',
        skuCode:'',
        nameZh:'',
        productName: '',
        productColor:'',
        productSize:'',
        productAttr1:'',
        productAttr2:'',
        receiverName: '',
      },
    }
  },
  computed:{
    showName(){
      if(this.optType===10){
        return '物料'
      }else if(this.optType===20){
        return '品番'
      }
    }
  },
  methods: {
    doSend (sendOptType) {
      this.sendOptType=sendOptType
      if (this.$c.isArrayEmpty(this.$refs.table.dataListSelections)) {
        return this.$message.error('请选择发货内容')
      }
      let detailList = this.$refs.table.dataListSelections.map(row => {
        return {
          orderCode: row.orderCode,
          orderId: row.agreementId||row.orderId,
          sourceId: row.id,
          productId: row.productId,
          product: row.product,
          count: '',
          receiverId: row.storageId,
          receiverName: row.storageName,
          remark: '',
          orderCount: row.count,
          receivedCount: row.receivedCount,
          sendCount:row.sendCount,
          price:0
        }
      })
      this.$refs.SendDialog.init(detailList)
    },
    beforeTableBinding (dataList) {

    },
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>


